'use client';

import { useState } from 'react';
import { FAQ_ITEMS } from '@/lib/services';

const ITEMS = FAQ_ITEMS;

function Chevron({ open }: { open: boolean }) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      style={{
        transition: 'transform 0.3s ease',
        transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
        color: open ? 'var(--accent)' : 'var(--text-muted)',
      }}
    >
      <polyline points="6 9 12 15 18 9" />
    </svg>
  );
}

export function FAQ() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section>
      <h2
        className="font-mono text-accent text-center mb-10"
        style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.2em' }}
      >
        FREQUENTLY ASKED
      </h2>
      <ul
        className="flex flex-col"
        style={{
          borderTop: '1px solid var(--border)',
        }}
      >
        {ITEMS.map((item, i) => {
          const open = openIdx === i;
          return (
            <li key={item.q} style={{ borderBottom: '1px solid var(--border)' }}>
              <button
                type="button"
                aria-expanded={open}
                onClick={() => setOpenIdx(open ? null : i)}
                className="w-full flex items-center justify-between gap-4 text-left transition-colors"
                style={{
                  padding: '20px 4px',
                  color: 'var(--text-primary)',
                }}
              >
                <span className="font-sans" style={{ fontSize: 15, fontWeight: 700 }}>
                  {item.q}
                </span>
                <Chevron open={open} />
              </button>
              <div
                className="grid transition-[grid-template-rows] duration-300 ease-out"
                style={{
                  gridTemplateRows: open ? '1fr' : '0fr',
                }}
              >
                <div style={{ overflow: 'hidden' }}>
                  <p
                    className="text-text-secondary"
                    style={{
                      fontSize: 14,
                      lineHeight: 1.7,
                      padding: '0 4px 20px',
                      maxWidth: 720,
                    }}
                  >
                    {item.a}
                  </p>
                </div>
              </div>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
